import axios from './../plugins/private-api-axios'

export const enumService = {
    config: {
        headers: {
            Authorization: ''
        }
    },
    async getVehicleDeviceTypes () {
        try {
            return await axios.get('/vehicleDeviceType', this.config)
        } catch (e) {
            throw e
        }
    },
    async getVehicleTypes () {
        try {
            return await axios.get('/vehicleType', this.config)
        } catch (e) {
            throw e
        }
    },
    async getFuelTypes () {
        try {
            return await axios.get('/fuelType', this.config)
        } catch (e) {
            throw e
        }
    },
    async getRoles () {
        try {
            return await axios.get('/role', this.config)
        } catch (e) {
            throw e
        }
    },
    async getEventTypes () {
        try {
            return await axios.get('/eventType', this.config)
        } catch (e) {
            throw e
        }
    },
    async getVehicleStatuesTypes () {
        try {
            return await axios.get('/vehicleStatus', this.config)
        } catch (e) {
            throw e
        }
    },
    async getSnapshotTypes () {
        try {
            return await axios.get('/snapshotType', this.config)
        } catch (e) {
            throw e
        }
    },
    async getRequestStatus () {
        try {
            return await axios.get('/requestStatus', this.config)
        } catch (e) {
            throw e
        }
    },
    async getRequestType () {
        try {
            return await axios.get('/requestType', this.config)
        } catch (e) {
            throw e
        }
    },
    async getDeviceIntegrations () {
        try {
            return await axios.get('/vehicleDeviceIntegration', this.config)
        } catch (e) {
            throw e
        }
    },
    async getDataToCapture () {
        try {
            return await axios.get('/dataToCapture', this.config)
        } catch (e) {
            throw e
        }
    },
    async getEventAlertLevelType () {
        try {
            return await axios.get('/eventAlertLevelType', this.config)
        } catch (e) {
            throw e
        }
    }
}

export const updateEnumService = (accessToken) => {
    enumService.config.headers.Authorization = accessToken
}

export default enumService
